<template>
  <div>
    <div class="flex flex-wrap items-center justify-between mb-2">
      <div class="text-muted">
        <span v-if="subscribers.length">{{ subscribers.length }} assinante(s)</span>
        <span v-else>Nenhum assinante ainda</span>
      </div>
      <b-button variant="outline-primary" size="sm" @click="load">
        <feather-icon icon="RefreshCwIcon" class="mr-50"/>
        <span class="align-middle">Atualizar</span>
      </b-button>
    </div>

    <vs-table :data="subscribers" no-data-text="Nenhum assinante encontrado">
      <template slot="thead">
        <vs-th>Aluno</vs-th>
        <vs-th>Situação</vs-th>
        <vs-th>Grade de horários</vs-th>
        <vs-th>Renova em</vs-th>
        <vs-th>Ação</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="`sub-${tr.subscription_id}`" v-for="tr in data">
          <vs-td>
            <div>{{ tr.user_name }}</div>
            <small class="text-muted">{{ tr.user_email }}</small>
          </vs-td>
          <vs-td>
            <vs-chip :color="statusColor(tr.status)">{{ tr.status_label }}</vs-chip>
          </vs-td>
          <vs-td>
            <div v-if="tr.slots.length" class="flex flex-wrap gap-1">
              <vs-chip v-for="slot in tr.slots" :key="slot.id" color="primary">
                {{ shortLabel(slot) }}
              </vs-chip>
            </div>
            <small v-else class="text-muted">Sem horários fixos</small>
          </vs-td>
          <vs-td>{{ tr.next_billing_at ? formatDate(tr.next_billing_at) : '—' }}</vs-td>
          <vs-td>
            <feather-icon
              icon="EyeIcon"
              style="cursor: pointer;"
              class="h-5 w-5 stroke-current text-primary"
              v-tooltip.auto="{ content: 'Abrir assinatura', delay: { show: 500, hide: 100 } }"
              @click="$router.push(`/subscriptions/${tr.subscription_id}`)"/>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import SubscriptionPlanService from '@/services/api/SubscriptionPlanService'

/**
 * Quem está neste plano e em que horários — a pergunta que o backoffice não
 * conseguia responder: a grid de assinaturas mostrava o plano, mas nunca a
 * grade de horários de cada assinante.
 */
export default {
  name: 'SubscriptionPlanSubscribers',
  components: { BButton },
  props: {
    id: { type: [String, Number], required: true },
  },
  data: () => ({
    subscribers: [],
  }),
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$vs.loading()
      SubscriptionPlanService.build(this.$vs).getSubscribers(this.id).then(
        data => { this.subscribers = Array.isArray(data) ? data : [] },
        () => this.notifyError(this.$vs, this.$t('messages.error')),
      ).finally(() => this.$vs.loading.close())
    },
    shortLabel(slot) {
      const map = {
        monday: 'Seg', tuesday: 'Ter', wednesday: 'Qua',
        thursday: 'Qui', friday: 'Sex', saturday: 'Sáb', sunday: 'Dom',
      }
      return `${map[slot.weekday] || slot.weekday} ${slot.start_time}`
    },
    statusColor(status) {
      return { AC: 'success', PE: 'warning', CA: 'danger', EX: 'dark', SP: 'warning' }[status] || 'primary'
    },
    formatDate(value) {
      if (!value) return '—'
      return new Date(value).toLocaleDateString('pt-BR')
    },
  },
}
</script>
